<template>
  <div class="PageHeader">
    <v-row class="d-flex">
      <v-col class="col-6 col-md-3 pt-0 order-0">
        <v-btn
          v-if="!hideButtons"
          text
          :disabled="leftButtonIsDisabled"
          class="theme-btn app-button-secondary color-white nice-padding mr-8"
          @click="$emit('clickLeftButton')"
        >
          <v-icon class="mr-2">arrow_back</v-icon>
          {{ leftButtonLabel }}
        </v-btn>
      </v-col>
      <v-col class="col-12 col-md-6 pt-0 order-2 order-md-1">
        <div class="text-center">
          <ColoredTag
            class="PageHeader_topic"
            color="purple-alt"
            :text="topic"
          />
          <div class="h-2-bold">
            {{ title }}
          </div>
        </div>
      </v-col>
      <v-col class="col-6 col-md-3 pt-0 text-right order-1 order-md-2">
        <v-btn
          v-if="!hideButtons"
          text
          :disabled="rightButtonIsDisabled"
          class="theme-btn app-button-primary color nice-padding"
          :class="{
            'grey-disabled': rightButtonIsDisabled,
          }"
          @click="$emit('clickRightButton')"
        >
          {{ rightButtonLabel }}
          <v-icon class="ml-2">arrow_forward</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-if="stepCount > 0"
      class="custom-progress-bar pt-6"
    >
      <v-progress-linear
        background-color="transparent"
        :color="progressBarColor"
        :value="progressValue"
        height="7"
        rounded
      />
    </v-row>
  </div>
</template>

<script>
  import ColoredTag from '@/components/ui/common/ColoredTag'
  import getColor from '@/utils/getColor'

  /*
   @todo = replace <v-icon class="mr-2">arrow_back</v-icon> by proper svg asset
   */

  export default {
    components: {
      ColoredTag,
    },
    props: {
      topic: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      leftButtonLabel: {
        type: String,
        default: '',
      },
      leftButtonIsDisabled: {
        type: Boolean,
        default: false,
      },
      rightButtonLabel: {
        type: String,
        default: '',
      },
      rightButtonIsDisabled: {
        type: Boolean,
        default: false,
      },
      hideButtons: {
        type: Boolean,
        default: false,
      },
      progressBarColor: {
        type: String,
        default: getColor('_009ee0'),
      },
      step: {
        type: [Number, null,],
        default: null,
      },
      stepCount: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      progressValue() {
        if (this.stepCount === 0) {
          return 0
        }

        return (100 * (this.step + 1)) / this.stepCount
      },
    },
  }
</script>

<style scoped lang="scss">
.PageHeader {
  width: 100%;

  &_topic {
    margin-bottom: 8px;
  }
}
</style>
